export default __webpack_public_path__ + "static/us-map-new-england-de75c6eeb1ed317a9aaba00ed0f95447.svg";